import React, { Fragment } from 'react';
import Navigation from './lp2/Navigation';
import Footer from './lp2/Footer';
import { Mail, Phone, MapPin } from 'lucide-react';

// Angaben uebernommen aus Privacy.js – dort standen sie bereits.
// TODO(philip): Falls eine Firma im Handelsregister eingetragen ist, gehoeren
// Rechtsform, UID (CHE-...) und ggf. MWST-Nummer hier ergaenzt. Ich habe
// bewusst nichts erfunden.
const Impressum = () => (
  <Fragment>
    <Navigation />
    <section className="bg-gradient-to-b from-blue-50 to-white min-h-screen py-16 px-4">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Impressum</h1>

        <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Verantwortlich für den Inhalt</h2>
            <p className="text-gray-700 leading-relaxed">
              Philip Hanke<br />
              EsGehtMirGut.ch
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Anschrift</h2>
            <p className="flex items-start gap-3 text-gray-700">
              <MapPin className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <span>Buchenegg 25<br />8143 Stallikon<br />Schweiz</span>
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Kontakt</h2>
            <div className="space-y-3">
              <p className="flex items-center gap-3 text-gray-700">
                <Mail className="w-5 h-5 text-blue-600 flex-shrink-0" />
                <a href="mailto:office@esgehtmirgut.ch" className="text-blue-600 hover:underline">
                  office@esgehtmirgut.ch
                </a>
              </p>
              <p className="flex items-center gap-3 text-gray-700">
                <Phone className="w-5 h-5 text-blue-600 flex-shrink-0" />
                <a href="tel:+41787923740" className="text-blue-600 hover:underline">
                  +41 78 792 37 40
                </a>
              </p>
            </div>
          </div>

          <div className="border-t pt-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Wichtiger Hinweis</h2>
            <p className="text-gray-700 leading-relaxed">
              EsGehtMirGut.ch ist <strong>kein Notrufdienst</strong> und ersetzt
              weder ärztliche Betreuung noch einen Pflegedienst. In einem Notfall
              wählen Sie bitte die <strong>144</strong>.
            </p>
          </div>

          <div className="border-t pt-6 text-sm text-gray-600">
            <p>
              Weitere Angaben finden Sie in der{' '}
              <a href="/privacy" className="text-blue-600 hover:underline">Datenschutzerklärung</a>
              {' '}und in den{' '}
              <a href="/agb" className="text-blue-600 hover:underline">AGB</a>.
            </p>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </Fragment>
);

export default Impressum;
